import { lighten, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { COLORS } from "../../../../constants";

export const menuSxPropsFn = ({
  displayOptionsAsChips,
}: {
  displayOptionsAsChips?: boolean;
}): SxProps<Theme> => ({
  ".MuiMenu-list": {
    paddingTop: 0,
  },
  ".MuiPaper-root": {
    minWidth: "230px",
  },
  ".MuiAutocomplete-paper": {
    boxShadow: "none",
  },
  ".MuiAutocomplete-listbox": {
    padding: (theme) => `${theme.spacing(1.5)} 0`,
    maxHeight: "283px",
    ".MuiAutocomplete-option": {
      minHeight: "auto",
      padding: (theme) =>
        displayOptionsAsChips
          ? `${theme.spacing(0.5)} ${theme.spacing(3)}`
          : `${theme.spacing(1.5)} ${theme.spacing(3)}`,
      "&.Mui-selected": {
        background: (theme) => lighten(theme.palette.primary.main, 0.88),
      },
      "&.Mui-focused": {
        background: (theme) => lighten(theme.palette.primary.main, 0.88),
      },
      "&:hover": {
        background: (theme) => lighten(theme.palette.primary.main, 0.88),
      },
    },
  },
});

export const chipSxProps = {
  "&.MuiChip-sizeSmall": {
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "0.4px",
    color: COLORS.P_MED_HIGH_EMPHASIS,
    height: "20px",
    borderRadius: "4px",
  },
  ".MuiChip-deleteIcon": {
    width: "12px",
    height: "12px",
  },
  ".MuiChip-label": {
    overflow: "visible",
  },
};

export const autocompleteSxProps = {
  ".MuiAutocomplete-inputRoot": {
    padding: (theme: Theme): string =>
      `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    borderBottom: `1px solid ${lighten(COLORS.BLACK, 0.88)} !important`,
    ".MuiAutocomplete-input": {
      fontSize: ["16px", "12px"],
      letterSpacing: "0.4px",
      lineHeight: "20px",
      padding: (theme: Theme): string => `0 ${theme.spacing(1)}`,
    },
  },
  ".MuiAutocomplete-endAdornment": {
    display: "none !important",
  },
};
